import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';

interface SnackBarData {
  message: string;
  icon: string;
  isError?: boolean;
  isYellow?: boolean;
  isRefresh?: boolean;
  actionLabel?: string;
}

@Component({
  selector: 'app-toast',
  imports: [MatIcon],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  constructor(
    public snackbarRef: MatSnackBarRef<ToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData
  ) {}
}
